module.exports = __webpack_public_path__ + "img/cloud.d045d8dc.png";